import type { ReactNode } from "react";
import { Book } from "react-feather";
import { useSignedImageUrl } from "../lib/signedImage";

// Renders a stored image value, signing a private-bucket path on demand (direct
// URLs/blobs pass straight through). Being a component, it's safe inside .map().
//   - className: extra classes on the default fill-parent <img>.
//   - imgClassName: full override of the <img> classes (for self-sized thumbnails).
//   - fallback: custom node shown when there's no image / while signing (defaults to
//     a centred book glyph).
export function StorageImage({
  stored,
  className = "",
  imgClassName,
  fallback,
}: {
  stored?: string | null;
  className?: string;
  imgClassName?: string;
  fallback?: ReactNode;
}) {
  const url = useSignedImageUrl(stored);
  if (url) {
    return (
      <img
        src={url}
        className={imgClassName ?? `w-full h-full object-cover ${className}`}
        alt=""
      />
    );
  }
  if (fallback !== undefined) return <>{fallback}</>;
  return (
    <div
      className={`w-full h-full flex items-center justify-center text-ink-faint ${className}`}
    >
      <Book className="w-1/3 h-1/3" />
    </div>
  );
}
